import { render, staticRenderFns } from "./loaderComponent.vue?vue&type=template&id=01d3c3e4&scoped=true"
import script from "./loaderComponent.vue?vue&type=script&lang=js"
export * from "./loaderComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d3c3e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\new-tis\\FR-TISSOT-IFB-Discovery-SFCC\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01d3c3e4')) {
      api.createRecord('01d3c3e4', component.options)
    } else {
      api.reload('01d3c3e4', component.options)
    }
    module.hot.accept("./loaderComponent.vue?vue&type=template&id=01d3c3e4&scoped=true", function () {
      api.rerender('01d3c3e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "cartridges/int_guidedProductFinder/cartridge/client/default/js/components/loaderComponent.vue"
export default component.exports